﻿import { useState } from 'react';
import { Alert, Stack, TextField, Paper, Button, styled } from '@mui/material';
import { WizardButtons } from '../../Wizard/WizardButtons';
import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as Yup from 'yup';
import './beneStyles.css';

const SpouseQuestionCaptureEmail = (props) => {
  const [isMarried, setIsMarried] = useState(null);
  const [spouseName, setSpouseName] = useState('');
  const [spouseEmail, setSpouseEmail] = useState('');

  // const validationSchema = Yup.object().shape({
  //     spouseEmail: Yup.string().required('Spouse email is required').email('Email is invalid'),
  //     spouseName: Yup.string().required('Spouse name is required')
  // });
  //
  // const { register, trigger, formState: { errors } } = useForm({
  //     resolver: yupResolver(validationSchema)
  // });
  const {
    register,
    trigger,
    formState: { errors },
  } = useForm();
  const ValidateForm = () => {
    if (isMarried)
      trigger().then((d) => {
        clickNext(d);
      });
    else clickNext(true);
  };

  const clickNext = (val) => {
    if (val) {
      let d = JSON.parse(window.sessionStorage.getItem('currentBene'));

      if (isMarried) {
        d.spouseEmail = spouseEmail;
        d.spouseNeeded = true;
        d.spouseName = spouseName;
        window.sessionStorage.setItem('currentBene', JSON.stringify(d));
      }

      if (d.coOwnerNeeded) props.nextHandler();
      else props.skipHandler(3);
    }
  };
  const isBoolean = (ownerEmail) => {
    if (ownerEmail) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <>
      {isMarried === null && (
        <Alert severity="info">
          <div>Are you currently married?</div>
          <div className="internalButton">
            <Button variant="contained" onClick={() => setIsMarried(true)}>
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                clickNext(true);
              }}
            >
              No
            </Button>
          </div>
        </Alert>
      )}
      {isMarried && (
        <>
          <Stack spacing={2}>
            <Alert severity="info">Please enter the spouses information.</Alert>
            <BeneFormItem>
              <span className="formLabel">Full Name:</span>
              <TextField
                {...register('spouseName')}
                error={isBoolean(errors.spouseName)}
                helperText={errors && errors.spouseName && errors.spouseName.message}
                className="fullwidth"
                placeholder="(First Last Suffix)"
                value={spouseName}
                onChange={(e) => {
                  setSpouseName(e.target.value);
                }}
              />
            </BeneFormItem>
            <BeneFormItem>
              <span className="formLabel">Email Address:</span>
              <TextField
                {...register('spouseEmail')}
                error={isBoolean(errors.spouseEmail)}
                helperText={errors && errors.spouseEmail && errors.spouseEmail.message}
                className="fullwidth"
                value={spouseEmail}
                onChange={(e) => {
                  setSpouseEmail(e.target.value);
                }}
              />
            </BeneFormItem>
          </Stack>
          <WizardButtons {...props} nextHandler={ValidateForm} />
        </>
      )}
    </>
  );
};

const decideColor = (theme) => {
  let color = '';
  if (theme.palette.mode === 'dark') {
    color = '#1A2027';
  } else {
    color = '#FFF';
  }
};

const BeneFormItem = styled(Paper)(({ theme }) => ({
  backgroundColor: decideColor(theme),
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '.25em',
  color: theme.palette.text.secondary,
}));

export { SpouseQuestionCaptureEmail };
